<template>
  <div class="h-[80px]  xl:px-[15%] px-4 flex items-center justify-between absolute top-0 left-0 right-0 z-50">
    <a :href="`/${lang}/marketplace`" class="flex items-center gap-4">
      <img src="/images/logo.svg" class="h-11 w-auto"/>
    </a>
    <div class="flex items-center gap-4">
      <div @click="openLanguageModal = true" class="border bg-white rounded-full px-2 py-2 font-semibold flex items-center gap-2 cursor-pointer">
        <i class="bi bi-globe"></i>
      </div>
      <a :href="cart ? `/${lang}/marketplace/cart` : '#'" v-if="cart" class="border bg-white rounded-full px-4 py-2 font-semibold flex items-center gap-2 cursor-pointer text-sm">
        {{ cart.attributes.profile_name }}
        <div class="font-bold w-6 h-6 text-xs rounded-full flex items-center justify-center bg-[#A8F1FF]">{{ cart.attributes.items_count }}</div>
      </a>
      <a :href="`/${lang}/marketplace/cart`" v-else class="border bg-white rounded-full px-4 py-2 font-semibold flex items-center gap-2 cursor-pointer text-sm">
        {{  i18n.t('marketplace.general.cart')  }}
      </a>
    </div>
    <LanguageModal v-if="openLanguageModal" @close="openLanguageModal = false" />
  </div>
</template>

<script>
import LanguageModal from './language_modal.vue';

export default {
  name: 'navbarComponent',
  props: {
    cart: {
      type: Object,
      required: false,
      default: null
    },
    showLanguageModalOnLoad: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    LanguageModal
  },
  data() {
    return {
      openLanguageModal: this.showLanguageModalOnLoad,
      lang: document.body.dataset.lang || 'en'
    }
  },
  methods: {
  }
}
</script>